<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <input
            :type="inputType"
            :value="value"
            class="wf-input"
            :class="{ 'wf-input--error': error }"
            @input="emitValue($event.target.value)"
        />
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import FieldMixin from './FieldMixin'
import { getFieldInputType } from '../fieldRegistry'

export default {
    name: 'DateField',
    mixins: [FieldMixin],
    computed: {
        inputType() {
            return getFieldInputType(this.attribute.form_attribute_type_id) || 'date'
        }
    }
}
</script>
